import n from '../../node_modules/rollup-plugin-styles/dist/runtime/inject-css.js';

var css = "@keyframes mbw_animationBzdot9__3a1e751f{0%{background-position:-200px 0}to{background-position:calc(200px + 100%) 0}}.mbw_labelGrayContainer__3a1e751f{align-items:center;background-color:#f7f7f7;border:.063rem solid #eaeaea;border-radius:31.25rem;display:flex;justify-content:center;padding:.1875rem .625rem;width:fit-content}@media (max-width:48rem){.mbw_labelGrayContainer__3a1e751f{padding:.063rem .313rem}}";
var modules_1a8f5c5e = {"label-gray-container":"mbw_labelGrayContainer__3a1e751f","animation-bzdot9":"mbw_animationBzdot9__3a1e751f"};
n(css,{});

export { css, modules_1a8f5c5e as default };
//# sourceMappingURL=label.module.scss.js.map
